import * as Yup from 'yup';

export const OrganizationValidation = () =>
  Yup.object().shape({
    id: Yup.string()
      .required('Organization ID is required')
      .matches(
        /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
        'Organization ID must be a valid UUID v4',
      ),
    name: Yup.string().required('Organization name is required'),
    email: Yup.string().email().required('Organization email is required'),
    contact_emails: Yup.array().of(Yup.string().email('Invalid email format')).nullable(),
    features: Yup.object(),
  });
